(function () {
  'use strict';

  if (window.__hsVideolyGalleryInstalled) return;
  window.__hsVideolyGalleryInstalled = true;

  function init() {
    var injected = false;
    var stopped = false;
    var scheduled = 0;
    var readinessTimer;
    var expiryTimer;
    var playbackTimer;
    var playbackToken = 0;
    var watchedRoot;
    var lastRaw;
    var youtubeVideos = [];
    var observer = new MutationObserver(schedule);

    function schedule() {
      if (injected || stopped || scheduled) return;

      scheduled = window.requestAnimationFrame(function () {
        scheduled = 0;
        injectVideos();
      });
    }

    function watch(root, attributes) {
      if (root === watchedRoot) return;

      observer.disconnect();
      watchedRoot = root;

      var options = {
        childList: true,
        subtree: true
      };

      if (attributes) {
        options.attributes = true;
        options.attributeFilter = ['videolist'];
      }

      observer.observe(root, options);
    }

    function stopWatching() {
      stopped = true;
      observer.disconnect();
      window.clearTimeout(readinessTimer);
      window.clearTimeout(expiryTimer);

      if (scheduled) {
        window.cancelAnimationFrame(scheduled);
      }

      scheduled = 0;
    }

    function parseVideos(slider) {
      var raw = slider.getAttribute('videolist') || '[]';

      if (raw === lastRaw) return youtubeVideos;

      lastRaw = raw;
      youtubeVideos = [];

      try {
        var list = JSON.parse(raw);

        if (!Array.isArray(list)) return youtubeVideos;

        var seen = new Set();

        list.forEach(function (video) {
          if (!video || video.type !== 'youtube') return;

          var id = String(video.providerVideoId || '');

          if (!/^[A-Za-z0-9_-]{11}$/.test(id) || seen.has(id)) {
            return;
          }

          seen.add(id);
          youtubeVideos.push(video);
        });
      } catch (_) {
        // Wacht op een volgende, geldige videolist-update.
      }

      return youtubeVideos;
    }

    function thumbnail(video, small) {
      var thumbs = video.thumbs || {};
      var candidate = small
        ? (thumbs.medium || thumbs.high)
        : thumbs.high;

      if (candidate && candidate.url) {
        try {
          var url = new URL(candidate.url, location.href);

          if (url.protocol === 'https:') return url.href;
        } catch (_) {}
      }

      return 'https://img.youtube.com/vi/' +
        video.providerVideoId +
        (small ? '/mqdefault.jpg' : '/hqdefault.jpg');
    }

    function picture(video, small) {
      var node = document.createElement('picture');
      var img = document.createElement('img');

      img.src = thumbnail(video, small);
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.setAttribute('fetchpriority', 'low');

      if (!small) {
        img.width = 430;
        img.height = 430;
        img.style.cssText =
          'object-position:unset;width:100%;display:block;';
      }

      node.appendChild(img);
      return node;
    }

    function playIcon(small) {
      var span = document.createElement('span');
      var size = small ? 16 : 52;
      var iconSize = small ? 8 : 26;

      span.setAttribute('aria-hidden', 'true');

      span.style.cssText =
        'position:absolute;top:50%;left:50%;' +
        'transform:translate(-50%,-50%);' +
        'width:' + size + 'px;height:' + size + 'px;' +
        'background:rgba(0,0,0,.65);border-radius:50%;' +
        'display:flex;align-items:center;justify-content:center;' +
        'pointer-events:none;z-index:2;';

      // Alleen vaste markup, geen videotitels of externe URL's.
      span.innerHTML =
        '<svg viewBox="0 0 24 24" fill="white"' +
        ' width="' + iconSize + '" height="' + iconSize + '">' +
        '<polygon points="5,3 19,12 5,21"/></svg>';

      return span;
    }

    function openVideo(video, event) {
      event.preventDefault();
      event.stopPropagation();

      var placeholder = document.getElementById(
        'videoly-videobox-placeholder'
      );

      if (!placeholder) return;

      var details = document.querySelector('.faq-videoly-tab');

      if (details && !details.open) {
        details.open = true;
      }

      placeholder.scrollIntoView({
        block: 'center',
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches ? 'auto' : 'smooth'
      });

      var token = ++playbackToken;
      window.clearTimeout(playbackTimer);

      var attempts = 0;

      function tryPlay() {
        if (token !== playbackToken) return;

        var slider = placeholder.querySelector('videoly-slider');
        var index = -1;

        if (slider) {
          try {
            var list = JSON.parse(
              slider.getAttribute('videolist') || '[]'
            );

            if (Array.isArray(list)) {
              index = list.findIndex(function (item) {
                return item &&
                  item.type === 'youtube' &&
                  item.providerVideoId === video.providerVideoId;
              });
            }
          } catch (_) {}
        }

        var tile = slider &&
          index >= 0 &&
          slider.tileElements &&
          slider.tileElements[index];

        if (tile && typeof tile.click === 'function') {
          tile.click();
          return;
        }

        if (++attempts < 20) {
          playbackTimer = window.setTimeout(tryPlay, 100);
        } else {
          console.warn(
            '[HS Videoly] Video kon niet automatisch openen; ' +
            'gebruik het videoblok.',
            video.providerVideoId
          );
        }
      }

      // Geef het geopende details-element gelegenheid om te renderen.
      window.requestAnimationFrame(function () {
        if (token === playbackToken) {
          playbackTimer = window.setTimeout(tryPlay, 0);
        }
      });
    }

    function bindControl(node, video) {
      node.setAttribute('role', 'button');
      node.tabIndex = 0;

      node.setAttribute(
        'aria-label',
        'Bekijk video: ' + (video.title || 'Productvideo')
      );

      node.addEventListener('click', openVideo.bind(null, video));

      node.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          openVideo(video, event);
        }
      });
    }

    function injectVideos() {
      if (injected || stopped) return;

      var placeholder = document.getElementById(
        'videoly-videobox-placeholder'
      );

      var wrapper = document.querySelector(
        'ul.l4pr .swiper-wrapper'
      );

      var swiperEl = document.querySelector(
        'ul.l4pr .swiper-outer'
      );

      var sw = swiperEl && swiperEl.swiper;

      if (placeholder) {
        watch(placeholder, true);
      }

      if (!placeholder || !wrapper || !sw || sw.destroyed) {
        // De Swiper-instance kan verschijnen zonder DOM-mutatie.
        window.clearTimeout(readinessTimer);
        readinessTimer = window.setTimeout(schedule, 500);
        return;
      }

      window.clearTimeout(readinessTimer);
      window.clearTimeout(expiryTimer);

      watch(placeholder, true);

      var slider = placeholder.querySelector('videoly-slider');

      if (!slider) return;

      var videos = parseVideos(slider);

      if (!videos.length) return;

      if (wrapper.querySelector('.has-video-slide')) {
        console.warn(
          '[HS Videoly] Videoslides bestaan al. ' +
          'Controleer op een dubbele adapter.'
        );

        stopWatching();
        return;
      }

      var first = wrapper.querySelector('.swiper-slide');

      var slideClass = first
        ? first.className.split(/\s+/).filter(function (name) {
            return !/^swiper-slide-(active|next|prev|duplicate.*)$/
              .test(name);
          }).join(' ')
        : 'swiper-slide';

      var fragment = document.createDocumentFragment();
      var createdSlides = [];
      var bullets = [];

      videos.forEach(function (video) {
        var slide = document.createElement('div');
        slide.className = slideClass + ' has-video-slide';
        slide.style.cursor = 'pointer';

        // Behoud de structuur van jullie bestaande galerijcode.
        var inner = document.createElement('li');
        inner.className = 'has-anchor li';
        inner.setAttribute('role', 'none');
        inner.style.position = 'relative';

        inner.append(
          picture(video, false),
          playIcon(false)
        );

        slide.appendChild(inner);
        bindControl(slide, video);

        fragment.appendChild(slide);
        createdSlides.push(slide);
      });

      // Stop observer vóór onze eigen DOM-wijzigingen.
      injected = true;
      stopWatching();

      try {
        // Behoud het niet-doorlopende gedrag uit de oude code.
        if (sw.params.loop) {
          if (typeof sw.loopDestroy === 'function') {
            sw.loopDestroy();
          }

          sw.params.loop = false;
        }

        wrapper.appendChild(fragment);
        sw.update();
      } catch (error) {
        console.warn(
          '[HS Videoly] Controleer de galerij na de Swiper-update.',
          error
        );
      }

      var pagination = document.querySelector(
        'ul.l4pr .swiper-pagination-clickable'
      );

      if (pagination) {
        var bulletFragment = document.createDocumentFragment();

        videos.forEach(function (video, index) {
          var bullet = document.createElement('a');

          bullet.className =
            'swiper-pagination-bullet has-video-bullet';

          bullet.setAttribute('data-video-index', index);

          bullet.setAttribute(
            'data-slide-index',
            Array.prototype.indexOf.call(
              wrapper.children,
              createdSlides[index]
            )
          );

          bullet.style.position = 'relative';

          bullet.append(
            picture(video, true),
            playIcon(true)
          );

          bindControl(bullet, video);

          bulletFragment.appendChild(bullet);
          bullets.push(bullet);
        });

        pagination.appendChild(bulletFragment);
      }

      function syncBullets() {
        bullets.forEach(function (bullet, index) {
          var slideIndex = Array.prototype.indexOf.call(
            wrapper.children,
            createdSlides[index]
          );

          bullet.classList.toggle(
            'video-bullet-active',
            sw.activeIndex === slideIndex
          );
        });
      }

      sw.on('slideChange', syncBullets);
      syncBullets();
    }

    watch(document.body, false);

    // Stop de brede zoektocht na 60 seconden.
    // Zodra placeholder en galerij bestaan, vervalt deze timer
    // en worden videolist-updates lokaal gevolgd.
    expiryTimer = window.setTimeout(stopWatching, 60000);

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})(); 